import { AnyStore } from 'src/stores';

export const selectorStore = new AnyStore(false);
